module["exports"] = [
  "Rojo",
  "Azul",
  "Negro",
  "Gris",
  "Blanco",
  "Amarillo",
  "Verde",
  "Morado",
  "Violeta"
]


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es/commerce/color.js
// module id = 2828
// module chunks = 1610